import React , {useRef, useState} from 'react'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from "react-spinners/ClipLoader"; 
import { Link } from 'react-router-dom'
import Autocomplete from "react-google-autocomplete";
import ReCAPTCHA from 'react-google-recaptcha';

const PartnerForm = ({ prm }) => {    
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const mapApiKey = process.env.REACT_APP_GOOGLE_PLACE_API_KEY;
  const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
  const [enquiry, setEnquiry] = useState(prm);
  const [companyLocation, setCompanyLocation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyMessage, setCompanyMessage] = useState(""); 
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(true);
  const [disableButton, setDisableButton] = useState(false);
  const [spinnerClass, setSpinnerClass] = useState('invisible');
  const [isVisible, setIsVisible] = useState('visible');
  const [showMessage, setShowMessage] = useState('invisible');  
  const [msg, setMsg] = useState("");

  const recaptchaRef = useRef(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);  
  const [isValidCaptcha, setIsValidCaptcha] = useState("");

  const handleCaptchaChange = (token) => {
    setIsCaptchaVerified(!!token);
  };

  const resetCaptcha = () => {
    recaptchaRef.current?.reset();
    setIsCaptchaVerified(false);
    setIsValidCaptcha("Valid");
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors({});
      return;
    }     
  };

  const toggleDisableButton = () => {
    setDisableButton(!disableButton);
    setIsChecked(!isChecked);
  };

  const changeClass = () => {
    setSpinnerClass('visible');
    setIsVisible('invisible');
  };

// Validation function for email and password
const validateForm = () => {
    const errors = {};
    if (!companyName) {
        errors.companyName = "Company name is required";
    }
    if (!contactPerson) {
        errors.contactPerson = "Contact person is required";
    }
    if (!companyPhone) {
        errors.companyPhone = "Contact number is required";
    }    
    if (!companyEmail) {
      errors.companyEmail = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(companyEmail)) {
      errors.companyEmail = "Please enter a valid email address";
    }
    if (!companyLocation) {
        errors.companyLocation = "Channel partner location is required";
    } 
    if (isCaptchaVerified === false) {
      errors.isValidCaptcha = "Please verify the CAPTCHA before submitting";
    }        
    return errors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    if (!isCaptchaVerified) {
      return;
    }    
    changeClass();
    const frmtype  = 1;
    const apiUrl = apiBaseUrl+`sendmail?form_type=${frmtype}&enquiry_type=${enquiry}&first_name=${companyName}&last_name=${contactPerson}&contact_number=${companyPhone}&email=${companyEmail}&location=${companyLocation}&message=${companyMessage}`;
    await axios.get(apiUrl).then((res)=>{
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setMsg(res.data.msg);
        //console.log('Send Data:', res);
        if (res.data.success === true) {
            toast("Mail sent successfully");
            setCompanyName("");
            setContactPerson("");
            setCompanyPhone("");
            setCompanyEmail("");
            setCompanyLocation("");
            setCompanyMessage("");
            setEnquiry(prm);
            setShowMessage('visible');
        } else {
            toast(res.data.error || "Mail not sent");
        }        
      }).catch((err)=>{
        //console.log('Invalid Email :', err);
        setSpinnerClass('invisible');
        setIsVisible('visible');
        setShowMessage('visible');
        toast("Something went wrong. Please try again later.");
    })
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  }; 

    return (
    <>
        <ToastContainer/>
        <form className="appoinment-form row" onSubmit={handleSubmit}>         
            <div className="form-group col-md-6">
                <label>Company name <span className="text-danger"><strong>*</strong></span></label>
                <input 
                    className="form-control" 
                    placeholder="Company name" 
                    type="text" 
                    name="company_name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    autoComplete="false"                  
                    required/>
                    {errors.companyName && <span className="error-message">{errors.companyName}</span>}
            </div>
            <div className="form-group col-md-6">
                <label>Contact person <span className="text-danger"><strong>*</strong></span></label>
                <input 
                    className="form-control" 
                    placeholder="Contact person" 
                    type="text" 
                    name="contact_person"
                    value={contactPerson}
                    onChange={(e) => setContactPerson(e.target.value)}
                    autoComplete="false"                
                    required/>
                    {errors.contactPerson && <span className="error-message">{errors.contactPerson}</span>}
            </div>                                
            <div className="form-group col-md-6">
                <label>Phone number <span className="text-danger"><strong>*</strong></span></label>
                <input 
                    className="form-control" 
                    placeholder="Phone number" 
                    type="text" 
                    name="company_phone"
                    maxLength={10}
                    value={companyPhone}
                    onChange={(e) => setCompanyPhone(e.target.value)}
                    autoComplete="false"                  
                    required/>
                    {errors.companyPhone && <span className="error-message">{errors.companyPhone}</span>}
        </div>
            <div className="form-group col-md-6">
                <label>Email <span className="text-danger"><strong>*</strong></span></label>
                <input 
                    className="form-control" 
                    placeholder="Email" 
                    type="email" 
                    name="company_email"
                    value={companyEmail}
                    onChange={(e) => setCompanyEmail(e.target.value)}
                    autoComplete="false"                
                    required/>
                    {errors.companyEmail && <span className="error-message">{errors.companyEmail}</span>}
            </div>                        
            <div className="form-group placeholder-wrap icon-form-outline col-md-12">
              <label>Channel partner location <span className="text-danger"><strong>*</strong></span></label>
              <i className="left fa fa-search"></i>
              <Autocomplete
                apiKey={mapApiKey}
                name="company_location" 
                className="form-control location-input" 
                type="text"
                placeholder='Channel partner location' 
                onPlaceSelected={(place) => {
                  //console.log(place?.formatted_address);
                  setCompanyLocation(place?.formatted_address)
                }}
                options={{
                  types: ["(regions)"],
                  componentRestrictions: { country: "in" },
                }}
                defaultValue={companyLocation}
                required/>                         
              <i className="right fa fa-map-marker"></i>
              {errors.companyLocation && <span className="error-message">{errors.companyLocation}</span>}
            </div>
            <div className="form-group col-md-12 col-sm-12 col-xs-12">
                <label>Message</label>
                <textarea 
                    className="form-control" 
                    rows="4" 
                    name="company_message"
                    value={companyMessage}
                    onChange={(e) => setCompanyMessage(e.target.value)}
                    autoComplete="false"                 
                    placeholder="Message"></textarea>
            </div>    
            <div className="form-group col-md-10 col-sm-10 col-lg-10 col-xs-9">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={recaptchaKey}
                className="input-control google-recaptch-wrapper"
                onChange={handleCaptchaChange}
              />  
            </div>
            <div className="col-md-2 col-sm-2 col-lg-2 col-xs-3 text-center">
              <span 
                className="form-control refresh-btn-wrapper" 
                onClick={resetCaptcha}><i className="fa fa-refresh"></i></span>
            </div>
            {errors.isValidCaptcha && 
            <>
            <div className="form-group col-md-12">
              <span className="error-message">{errors.isValidCaptcha}</span>
            </div>
            </>
            } 
            
            

            <div className="form-group col-md-12 col-sm-12 col-xs-12">
                <p><input 
                    type="checkbox" 
                    name="chkPolicy"
                    onChange={toggleDisableButton}
                    checked = { isChecked } 
                    required /> You agree to our <Link to="/privacy-policy" onClick={scrollToTop}>privacy policy</Link>.</p>
            </div>
            <div className="form-group col-md-12 col-sm-12 col-xs-12 text-center">
                <button 
                    className={`${isVisible} btn btn-lg btn-appointment-submit`}
                    type="submit" 
                    disabled={disableButton}>
                        Request Call Back
                </button>                                    
                <span className={`${spinnerClass} btn btn-lg btn-appointment-submit`}>
                    <ClipLoader
                        loading={true}
                        size={30}
                        color={"#ffffff"}/>                            
                </span>                                    
            </div>
            {!!(msg) && (
              <div className="form-group col-md-12 col-sm-12 col-xs-12 custom-message text-center">
                <span className={`${showMessage} text-center text-success`}>{msg}</span>  
              </div>
            )}             

        </form>
    </>    
    )
}

export default PartnerForm